import { render } from "./overseas-transfer.vue?vue&type=template&id=0e5ccd31"
import script from "./overseas-transfer.vue?vue&type=script&lang=js"
export * from "./overseas-transfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__